<template lang="pug">
  div
    app-dialog(v-model="$_show" header="Задать цвет тегу")
      v-form(ref="formColorTag")
        app-select(v-model="form.tag" label="Тег" :items="tags" item-text="name" @input="selectTag" return-object)
        app-text-field(v-model="form.tag.name" label="Название тега")
        //- v-color-picker(v-model="color" width="100%" :swatches="swatches" hide-canvas hide-inputs hide-mode-switch show-swatches )
        v-color-picker(v-model="color" width="100%" hide-canvas hide-inputs hide-mode-switch show-swatches )

        v-layout.mt-4
            v-flex.text-left
              v-btn.text-none(dark color="#ED0E51" :disabled="!form.tag.name" text large @click="dialog.dialogDelEventTag=true") Удалить
            v-flex.text-right
              v-btn.text-none.event-action(color="#1B93AD" :disabled="!form.tag.name" large depressed @click="save()") Сохранить

    app-dialog-confirm(v-model="dialog.dialogDelEventTag" @confirm="remove()")
      app-card-title.mt-5 
        b Вы точно хотите удалить тег - 
        | {{form.tag.name}} ?

</template>


<script>
import { mapState } from 'vuex'
import { AppDialogConfirm, AppDialogToggable } from '@/components'
import { eventService } from "@/_services";
export default {
  mixins: [AppDialogToggable],

  components: { [AppDialogConfirm.name]: AppDialogConfirm },

  data () {
    const defaultForm = Object.freeze({
      tag: {
        name: null,
        color: null
      },
    })
    return {
      dialog: {
        dialogDelEventTag: false
      },
      type: 'hex',
      hex: '#cccccc',
      form: Object.assign({}, defaultForm),
      defaultForm,
      swatches: [
        ['#FF0000', '#AA0000', '#550000'],
        ['#FFFF00', '#AAAA00', '#555500'],
        ['#00FF00', '#00AA00', '#005500'],
        ['#00FFFF', '#00AAAA', '#005555'],
        ['#0000FF', '#0000AA', '#000055'],
      ],
    }
  },

 watch: {
    $_show (value) {
      if (value) {
        this.form = JSON.parse(JSON.stringify(this.defaultForm))
      }
    },
  },

  computed: {
    ...mapState('event', ['tags']),

    color: {
      get () {
        return this[this.type]
      },
      set (v) {
        this[this.type] = v
      }
    }
  },


  methods: {
    selectTag (tag) {
      this.hex = tag.color ? tag.color : this.hex
    },

    save () {
      this.form.tag.color = this.color
      eventService.editEventTag(this.form.tag).then(() => {
        this.$store.dispatch('event/init')
        this.$_show = false
      })
    },

    remove () {
      eventService.removeEventTag(this.form.tag.id).then(() => {
        this.dialog.dialogDelEventTag = false
        this.$_show = false
        this.$store.dispatch('event/init')
      })
    },
  }
}
</script>


